<template>
  <div :class="{ 'wrapper' : wrapper }">
    <div class="heading" :class="{ 'mb-4': smallBottomMargin }">
      <h1><slot></slot></h1>
      <p>
        <span class="typed-text">{{ typeValue }}</span>
        <span class="cursor" :class="{'typing': typeStatus}">&nbsp;</span>
      </p>
    </div>
  </div>
</template>

<script >
import {setTimeout} from "timers";

export default {
    name: "BaseHeading",
    props: {
      wrapper: {
        type: Boolean,
        default: true
      },
      smallBottomMargin: {
        type: Boolean,
        default: false
      },
      typeArray: {
        type: Array,
        required: true,
        default: () => ['Test Value','Test Value 2'],
      }
    },
  data: () => {
    return {
      typeValue: '',
      typeStatus: false,
      typingSpeed: 100,
      erasingSpeed: 100,
      newTextDelay: 2000,
      typeArrayIndex: 0,
      charIndex: 0
    }
  },
  methods: {
    typeText() {
      if(this.charIndex < this.typeArray[this.typeArrayIndex].length) {
        if(!this.typeStatus)
          this.typeStatus = true;
        this.typeValue += this.typeArray[this.typeArrayIndex].charAt(this.charIndex);
        this.charIndex += 1;
        setTimeout(this.typeText, this.typingSpeed);
      }
      else {
        this.typeStatus = false;
        setTimeout(this.eraseText, this.newTextDelay);
      }
    },
    eraseText() {
      if(this.charIndex > 0) {
        if(!this.typeStatus)
          this.typeStatus = true;
        this.typeValue = this.typeArray[this.typeArrayIndex].substring(0, this.charIndex - 1);
        this.charIndex -= 1;
        setTimeout(this.eraseText, this.erasingSpeed);
      }
      else {
        this.typeStatus = false;
        this.typeArrayIndex += 1;
        if(this.typeArrayIndex >= this.typeArray.length)
          this.typeArrayIndex = 0;
        setTimeout(this.typeText, this.typingSpeed + 1000);
      }
    }
  },
  created() {
    this.typeText();
  }
}
</script>

<style scoped>
.wrapper {
  text-align:center;
}

.heading {
  margin-bottom:50px;
  display: inline-block;
  position:relative;
  transition: all 0.3s;
}

h1 {
  font-size:40px;
  margin:0;
  text-transform:uppercase;
  position:relative;
  width:auto;
  font-weight:500;
  padding-bottom:15px;
}

h1:after {
  content:"";
  position:absolute;
  background-color:#202020;
  width:100%;
  height:2px;
  top:100%;
  left:0;
}

p {
  font-size: 1rem;
  text-align: right;
  text-transform: uppercase;
  background-color: #ffffff;
  margin: 0;
  padding-left: 2px;
  position: absolute;
  right: 0;
  bottom: -10px;
  font-weight: 800;
}

span.typed-text {
  color: #f6483b;
}
span.cursor {
  display: inline-block;
  margin-left: 3px;
  width: 4px;
  background-color: #fff;
  animation: cursorBlink 1s infinite;
}
span.cursor.typing {
  animation: none;
}
@keyframes cursorBlink {
  49% { background-color: #fff; }
  50% { background-color: transparent; }
  99% { background-color: transparent; }
}
</style>